import "./loader.css";

function Loader() {
    return (
        <div className="loader-wrapper centered">
            <div className="loader"></div>
        </div>
    );
}

export { Loader };
